import type { TenantConfig } from '@/types/TenantConfig'

export const enchant: TenantConfig = {
  logo: 'assets/enchant/static/logo.svg',
  themeOptions: {
    primaryColor: '#0B2B42',
    secondaryColor: '#ae9277',
    headerBackground: 'black',
    footerBackgroundColor: '#0B2B42',
    footerTextColor: '#ae9277',
    logoHeight: '45px',
    cartHeaderBackgroundColor: '#0B2B42',
  },
  componentOptions: {
    stripeCreditCard: {
      fontFaceStylesheet: 'https://use.typekit.net/tsu4pxd.css',
    },
    completedOrdersRoute: {
      completedImage: {
        desktop: 'assets/enchant/static/completed.jpg',
      },
      completedContentOffset: {
        desktop: '-200px',
        mobile: '-150px',
      },
    },
  },
}
